import promotionLightDestop from "assets/hm_service_image/promotiondarkedstop.png";
import produo from "assets/hm_service_image/udduo.png";
import promotionplusDestop from "assets/hm_service_image/promotiondarkedstop.png";

import promotionLightMobile from "assets/hm_service_image/promotiondarkedstop.png";
import produomb from "assets/hm_service_image/udduo.png";
import promotionDarkMobile from "assets/hm_service_image/promotiondarkedstop.png";
export const PromotionProduct = ({ theme, isplus, isduo }) => {
  const isLight = theme === "light";

  return (
    <div className="section-product">
      {isLight ? (
        <img
          className="f-desktop"
          src={promotionLightDestop}
          alt=""
          style={{ width: "130%", margin: "20px 0" }}
        />
      ) : isduo ? (
        <img
          className="f-desktop"
          src={produo}
          alt=""
          style={{ width: "130%", margin: "20px 0" }}
        />
      ) : (
        <img
          className="f-desktop"
          src={promotionplusDestop}
          alt=""
          style={{ width: "130%", margin: "20px 0" }}
        />
      )}


      {isLight ? (
        <img className="f-mb" src={promotionLightMobile} alt='' style={{ width: 'auto', margin: '20px 0' }} />
      ) : isduo ? (
        <img
          className="f-mb"
          src={produomb}
          alt=""
          style={{ width: "130%", margin: "20px 0" }}
        />
      )
        : (
          <img className="f-mb" src={promotionDarkMobile} alt='' style={{ width: 'auto', margin: '20px 0' }} />
        )
      }
    </div>
  );
};
